<template>
  <CContainer :fluid="true" class='order-modal p-3'>
        
          
            <CRow>
                <CCol class='text-center text-sm-left'>
                    <h2>Datos de la solicitud</h2>
                </CCol>
                <CCol sm="12">
                    <CListGroup>
                        <CListGroupItem 
                        href="#" 
                        color="dark"
                        >
                            <CRow class="d-flex">
                                 
                            <CCol col="3" sm="4">
                                    <span class='d-none d-sm-block'>Nombre del Producto</span>
                                    <span class='d-sm-none'>N. del Producto</span>
                                </CCol>
                                <CCol col="3" sm="3">
                                    <span class='d-none d-sm-block'>Cantidad</span>
                                    <span class='d-sm-none'>Cant.</span>
                                </CCol>
                                <CCol col="3" sm="2">
                                    <span class='d-none d-sm-block'>Precio por unidad</span>
                                    <span class='d-sm-none'>Precio unitario</span>
                                </CCol>
                                <CCol col="3" sm="2">
                                    Subtotal
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                          <CListGroupItem 
                        href="#" 
                        color="light"
                        
                        >
                            <CRow class="d-flex" v-for='(item, i) in order.description.items' :key='`item-${i}`'>
                               
                                <CCol col="3" sm="4" class='text-truncate'>
                                    {{item.name}}
                                </CCol>
                                <CCol col="3" sm="3">
                                    {{item.quantity}}
                                </CCol>
                                <CCol col="3" sm="2">
                                    {{setNumberWithCommas(item.price)}}
                                </CCol>
                                <CCol col="3" sm="2">
                                    {{setNumberWithCommas(item.subtotal)}}
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                    </CListGroup>
                </CCol>
            </CRow>
             <br>
            <CRow>
                
                <CCol sm='12'>
                    <CListGroup>
                        <CListGroupItem>
                            <CRow>
                                 <CCol>
                                    <label for="" class='w-100'>Fecha de creación: <b>{{order.created_at}}</b></label>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md='3' class='order-2 order-md-1'>
                                    <CInput
                                        :value.sync='order.priority.name'
                                        ref="priority_id"
                                        label='Prioridad' 
                                        disabled
                                        />
                                </CCol>
                                <CCol md='3' class='order-3 order-md-2'>
                                    <CInput
                                        :value.sync='order.department.name'
                                        ref="department_id"
                                        label='Sector'
                                        disabled
                                        />
                                </CCol> 
                                <CCol md='3' class='order-4 order-md-3'>
                                    <CInput
                                        :value='order.scheduled_order ? "Automática" : "Normal"'
                                        ref="scheduled_order"
                                        label='Tipo de solicitud'
                                        disabled
                                       />
                                </CCol>
                                <CCol md='3' class='order-1 order-md-4'>
                                    <CInput :value.sync='orderTotal' disabled label='Total' >                                            
                                        <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                </CCol>
                                
                            </CRow>
                            
                            <CRow>
                                <CCol md='6' class='order-2 order-md-1'>
                                    <CTextarea :value.sync='order.description.text' placeholder='Mensaje' disabled/>
                                </CCol>
                                <CCol md='3' class='order-1 order-md-2' v-if='order.scheduled_order'>
                                    <CInput 
                                        
                                        :value='order.scheduled_order.days'
                                        ref="days"
                                        label='Cantidad de días' 
                                        disabled
                                        />
                                </CCol>
                           
                                <CCol md='4' class='order-4 order-md-4 buttons-container'>
                                    <label for="" class='w-100'>Acciones</label>
                                    <CButton color='success' class='mr-2 mr-sm-0 mb-0 mb-sm-0 buttons' @click="downloadOrder">
                                        Descargar
                                    </CButton>
                                    <CButton color='danger' class='ml-2 ml-xl-4 buttons' @click="closeModal">
                                        Cerrar
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                    </CListGroup>
                </CCol>
            </CRow>
  </CContainer>
</template>

<script>
export default {
    props: {
        order: {
            required: true
        }
    },
    computed: {

        orderTotal(){
            if(typeof this.order.description === 'string'){
                this.order.description = JSON.parse(this.order.description)
            }
            let orderItemsLength = this.order.description.items.length;
            let total = 0;
       
            for (let i = 0; i < orderItemsLength; i++){
                total = total + parseFloat(this.order.description.items[i].subtotal);
               
            }

            return parseFloat(total).toFixed(2).toString().replace('.', ',');
        }
    },
    methods: {
        closeModal(){
            this.$root.$emit('close-modal')
        },
        downloadOrder(){
            this.$api.orders.download(this.order.id)
            .then(res => {
                if(res.data.file){
                    let link = document.createElement('a');
                    link.download = this.order.id + '.pdf';
                    link.href = 'data:application/octet-stream;base64,' + res.data.file;
                    link.click();
                }
            })
            .catch(error => {
                this.$swal.fire({
                    titleText: 'Error',
                    text: 'Hubo un problema al generar la descarga',
                    icon: 'error'
                })
                console.log(error)
            })
        },
        setNumberWithCommas(value){
            let floatNumber = parseFloat(value);
            if (isNaN(floatNumber)){
                return 'N/A';
            } else {
                return  `$${floatNumber.toFixed(2).toString().replace('.', ',')}`;
            }
          
        },
    },
}
</script>

<style lang='scss' scoped>
.order-modal{
    max-height: calc(100vh - 2rem);
    overflow-y: scroll;
    background-color: white;
    border-radius: 4px;
    @media screen and (min-width: 768px){
        overflow-y: auto;
    }
}
</style>